import { createContext, useContext, useMemo, useState } from "react";
import {
  getFirestore,
  collection,
  addDoc,
  getDoc,
  getDocs,
  doc,
  runTransaction,
  onSnapshot,
  setDoc,
  where,
  query,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";
import { localModeMethods } from "./localModeMethods";

const DatabaseContext = createContext(null);

export const DatabaseContextProvider = ({ children }) => {
  const [localMode, setLocalMode] = useState(false);
  const db = useMemo(() => getFirestore(), []);
  const value = useMemo(
    () =>
      localMode
        ? { ...localModeMethods, localMode, setLocalMode }
        : {
            db,
            collection,
            addDoc,
            getDoc,
            getDocs,
            doc,
            runTransaction,
            onSnapshot,
            setDoc,
            where,
            query,
            updateDoc,
            deleteDoc,
            localMode,
            setLocalMode,
          },
    [db, localMode]
  );
  return (
    <DatabaseContext.Provider value={value}>
      {children}
    </DatabaseContext.Provider>
  );
};

export const useDatabase = () => {
  return useContext(DatabaseContext);
};
